// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedIntrabeam_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.5001 2C17.6678 2 17.8344 2.00434 18 2.01293V2H19V3H21V0H17V0.0106771C11.0465 0.265397 6.26543 5.0465 6.01074 11H6V15H8V11H8.013C8.27301 5.98572 12.4211 2 17.5001 2Z" class="svg-bg"/>
  <path d="M22 10V4H18V10H22ZM21 11V14L20.2426 17.0296C20.6777 17.138 21 17.5314 21 18 21 18.5523 20.5523 19 20 19 19.4477 19 19 18.5523 19 18 19 17.5314 19.3223 17.138 19.7574 17.0296L19 14V11H21ZM11 24V16H3V24H5V18H9V24H11Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.5974 2.00049C21.7323 2.00184 21.8665 2.00601 22 2.01293V2.00049H23V3H25V0L21.6072.000488281C21.5715.000162995 21.5358 0 21.5001 0 21.4643 0 21.4286.000162995 21.393.000488281H21V.0106771C15.0465.265397 10.2654 5.0465 10.0107 11L11 11.0005 12.013 11C12.2713 6.01779 16.3682 2.05102 21.4027 2.00049H21.5974ZM10 11.0005H11 12V15.0005H10V11.0005Z" class="svg-bg"/>
  <path d="M26 4H22V10H26V4ZM23 11H25V14L24.2426 17.0296C24.6777 17.138 25 17.5314 25 18 25 18.5523 24.5523 19 24 19 23.4477 19 23 18.5523 23 18 23 17.5314 23.3223 17.138 23.7574 17.0296L23 14V11ZM9 18H13V29H10.8293C10.9398 29.3128 11 29.6494 11 30 11 30.3506 10.9398 30.6872 10.8293 31H15V16H7V27.1707C7.31278 27.0602 7.64936 27 8 27 8.35064 27 8.68722 27.0602 9 27.1707V18Z" class="svg-bg"/>
  <path d="M10 30.0005C10 31.1051 9.10457 32.0005 8 32.0005C6.89543 32.0005 6 31.1051 6 30.0005C6 28.8959 6.89543 28.0005 8 28.0005C9.10457 28.0005 10 28.8959 10 30.0005Z" class="svg-bg"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M32.5 2C32.6673 2 32.834 2.00283 33 2.00846V2H35V4H37V0H33V.00743112C32.8339.00248871 32.6673 0 32.5 0 23.3873 0 16 7.3873 16 16.5 16 16.6673 16.0025 16.8339 16.0074 17H18.0085C18.0028 16.834 18 16.6673 18 16.5 18 8.49187 24.4919 2 32.5 2ZM16 17.0005H18V22.0005H16V17.0005ZM13 26H21V44H16.9C16.9656 44.3231 17 44.6575 17 45 17 45.3425 16.9656 45.6769 16.9 46H23V24H11V40.1C11.3231 40.0344 11.6575 40 12 40 12.3425 40 12.6769 40.0344 13 40.1V26Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 48C13.6569 48 15 46.6569 15 45C15 43.3431 13.6569 42 12 42C10.3431 42 9 43.3431 9 45C9 46.6569 10.3431 48 12 48ZM12 46C12.5523 46 13 45.5523 13 45C13 44.4477 12.5523 44 12 44C11.4477 44 11 44.4477 11 45C11 45.5523 11.4477 46 12 46Z" class="svg-bg"/>
  <path d="M34 6H38V14H34V6ZM37 16H35V19L35.8038 23.0192C35.3455 23.1104 35 23.5149 35 24 35 24.5523 35.4477 25 36 25 36.5523 25 37 24.5523 37 24 37 23.5149 36.6545 23.1104 36.1962 23.0192L37 19V16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedIntrabeam is a generated icon component.
 */
let IconMedIntrabeam = IconMedIntrabeam_1 = class IconMedIntrabeam extends IconBaseElement {
    render() {
        return html `${IconMedIntrabeam_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedIntrabeam.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedIntrabeam = IconMedIntrabeam_1 = __decorate([
    customElement('zui-icon-med-intrabeam')
], IconMedIntrabeam);
export { IconMedIntrabeam };
